import { render, staticRenderFns } from "./orderDetailMore.vue?vue&type=template&id=6a7561f8&scoped=true"
import script from "./orderDetailMore.vue?vue&type=script&lang=ts"
export * from "./orderDetailMore.vue?vue&type=script&lang=ts"
import style0 from "./orderDetailMore.vue?vue&type=style&index=0&id=6a7561f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7561f8",
  null
  
)

export default component.exports